"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./confirmation/index.js"),t=require("./modal/index.js"),o={Confirmation:e.default,Modal:t.default};exports.Confirmation=e.default,exports.Modal=t.default,exports.default=o;
//# sourceMappingURL=index.js.map
